import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Row, Col, Card, Label, FormFeedback, Input } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import { useFormik } from "formik";
import { loginUser } from "../../store/actions";

// Images
import bg from "../../assets/images/bg.jpg";
import logoDark from "../../assets/images/logo.png";

const Login2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { error, loading } = useSelector((state) => state.Account);

  // Clear error after timeout
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        dispatch({ type: "API_ERROR", payload: null });
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [error, dispatch]);

  // Form validation
  const validation = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    validationSchema: Yup.object({
      email: Yup.string().required("Please enter your email"),
      password: Yup.string().required("Please enter your password"),
    }),

    onSubmit: (values) => {
      dispatch(loginUser(values, navigate));
    },
  });

  document.title = "Login | Welcome To Moeen";

  return (
    <div className="account-pages">
      <div
        className="accountbg"
        style={{
          background: `url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>

      <div className="wrapper-page account-page-full">
        <Card className="shadow-none">
          <div className="card-block">
            <div className="account-box">
              <div className="card-box shadow-none p-4">
                <div className="p-2">
                  <div className="text-center">
                    <Link to="/">
                      <img src={logoDark} height="100" alt="logo" />
                    </Link>
                  </div>

                  <h4 className="font-size-18 text-center">Welcome Back!</h4>
                  <p className="text-muted text-center">
                    Sign in to continue to Moeen.
                  </p>

                  {/* Show backend error */}
                  {error && (
                    <div className="alert alert-danger text-center">{error}</div>
                  )}

                  <form
                    className="mt-4"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                    action="#"
                  >
                    {/* Email Field */}
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="email">
                        Email Address
                      </Label>
                      <Input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Enter email address"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email}
                        invalid={!!(validation.touched.email && validation.errors.email)}
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                      ) : null}
                    </div>

                    {/* Password Field */}
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="password">
                        Password
                      </Label>
                      <Input
                        type="password"
                        name="password"
                        id="password"
                        placeholder="Enter password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password}
                        invalid={
                          validation.touched.password && validation.errors.password ? true : false
                        }
                      />
                      {validation.touched.password && validation.errors.password ? (
                        <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                      ) : null}
                    </div>

                    {/* Remember Me + Login */}
                    <Row className="mb-3">
                      <Col sm={6}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customControlInline"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="customControlInline"
                          >
                            Remember me
                          </label>
                        </div>
                      </Col>
                      <Col sm="6" className="text-end">
                        <button
                          className="btn btn-primary w-md waves-effect waves-light"
                          type="submit"
                        >
                          Log In
                        </button>
                      </Col>
                    </Row>

                    {/* Forgot Password */}
                    <Row className="mb-3 mt-2 mb-0">
                      <Col className="mt-3">
                        <Link to="/pages-recoverpw-2" className="color-success">
                          <i className="mdi mdi-lock"></i> Forgot your password?
                        </Link>
                      </Col>
                    </Row>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Login2;
